/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputMissionDropData } from './OutputMissionDropData';
import {
    OutputMissionDropDataFromJSON,
    OutputMissionDropDataFromJSONTyped,
    OutputMissionDropDataToJSON,
} from './OutputMissionDropData';

/**
 * 
 * @export
 * @interface OutputHistoryEvent
 */
export interface OutputHistoryEvent {
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    ammo: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    channel: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    channel2?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    controlFrequency: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    craftName: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    dayTeamNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    deltaPayload?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    deltaStatus?: OutputHistoryEventDeltaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    direction: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    division: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    droneUid: string;
    /**
     * 
     * @type {Array<OutputMissionDropData>}
     * @memberof OutputHistoryEvent
     */
    drops?: Array<OutputMissionDropData>;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    dropsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    freq: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    freq2?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    missionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    pilot: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    repeaterChannel: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    stockAmmoId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    stockAmmoName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputHistoryEvent
     */
    stockDroneId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    stockDroneName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputHistoryEvent
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    target: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    targetStatus: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    targetType: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    team: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    timeEnd: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    timeStart: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    video: string;
    /**
     * 
     * @type {boolean}
     * @memberof OutputHistoryEvent
     */
    withRepeater: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputHistoryEvent
     */
    zone: string;
}


/**
 * @export
 */
export const OutputHistoryEventDeltaStatusEnum = {
    None: 'none',
    Nodata: 'nodata',
    Queued: 'queued',
    Delivered: 'delivered',
    Error: 'error'
} as const;
export type OutputHistoryEventDeltaStatusEnum = typeof OutputHistoryEventDeltaStatusEnum[keyof typeof OutputHistoryEventDeltaStatusEnum];


/**
 * Check if a given object implements the OutputHistoryEvent interface.
 */
export function instanceOfOutputHistoryEvent(value: object): boolean {
    if (!('ammo' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('controlFrequency' in value)) return false;
    if (!('craftName' in value)) return false;
    if (!('direction' in value)) return false;
    if (!('division' in value)) return false;
    if (!('droneUid' in value)) return false;
    if (!('duration' in value)) return false;
    if (!('freq' in value)) return false;
    if (!('id' in value)) return false;
    if (!('pilot' in value)) return false;
    if (!('repeaterChannel' in value)) return false;
    if (!('target' in value)) return false;
    if (!('targetStatus' in value)) return false;
    if (!('targetType' in value)) return false;
    if (!('team' in value)) return false;
    if (!('timeEnd' in value)) return false;
    if (!('timeStart' in value)) return false;
    if (!('type' in value)) return false;
    if (!('video' in value)) return false;
    if (!('withRepeater' in value)) return false;
    if (!('zone' in value)) return false;
    return true;
}

export function OutputHistoryEventFromJSON(json: any): OutputHistoryEvent {
    return OutputHistoryEventFromJSONTyped(json, false);
}

export function OutputHistoryEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputHistoryEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'ammo': json['ammo'],
        'channel': json['channel'],
        'channel2': json['channel2'] == null ? undefined : json['channel2'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'controlFrequency': json['controlFrequency'],
        'craftName': json['craftName'],
        'dayTeamNumber': json['dayTeamNumber'] == null ? undefined : json['dayTeamNumber'],
        'deltaPayload': json['deltaPayload'] == null ? undefined : json['deltaPayload'],
        'deltaStatus': json['deltaStatus'] == null ? undefined : json['deltaStatus'],
        'direction': json['direction'],
        'division': json['division'],
        'droneUid': json['droneUid'],
        'drops': json['drops'] == null ? undefined : ((json['drops'] as Array<any>).map(OutputMissionDropDataFromJSON)),
        'dropsCount': json['dropsCount'] == null ? undefined : json['dropsCount'],
        'duration': json['duration'],
        'freq': json['freq'],
        'freq2': json['freq2'] == null ? undefined : json['freq2'],
        'id': json['id'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'pilot': json['pilot'],
        'repeaterChannel': json['repeaterChannel'],
        'stockAmmoId': json['stockAmmoId'] == null ? undefined : json['stockAmmoId'],
        'stockAmmoName': json['stockAmmoName'] == null ? undefined : json['stockAmmoName'],
        'stockDroneId': json['stockDroneId'] == null ? undefined : json['stockDroneId'],
        'stockDroneName': json['stockDroneName'] == null ? undefined : json['stockDroneName'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'target': json['target'],
        'targetStatus': json['targetStatus'],
        'targetType': json['targetType'],
        'team': json['team'],
        'timeEnd': json['timeEnd'],
        'timeStart': json['timeStart'],
        'type': json['type'],
        'video': json['video'],
        'withRepeater': json['withRepeater'],
        'zone': json['zone'],
    };
}

export function OutputHistoryEventToJSON(value?: OutputHistoryEvent | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ammo': value['ammo'],
        'channel': value['channel'],
        'channel2': value['channel2'],
        'comment': value['comment'],
        'controlFrequency': value['controlFrequency'],
        'craftName': value['craftName'],
        'dayTeamNumber': value['dayTeamNumber'],
        'deltaPayload': value['deltaPayload'],
        'deltaStatus': value['deltaStatus'],
        'direction': value['direction'],
        'division': value['division'],
        'droneUid': value['droneUid'],
        'drops': value['drops'] == null ? undefined : ((value['drops'] as Array<any>).map(OutputMissionDropDataToJSON)),
        'dropsCount': value['dropsCount'],
        'duration': value['duration'],
        'freq': value['freq'],
        'freq2': value['freq2'],
        'id': value['id'],
        'missionType': value['missionType'],
        'pilot': value['pilot'],
        'repeaterChannel': value['repeaterChannel'],
        'stockAmmoId': value['stockAmmoId'],
        'stockAmmoName': value['stockAmmoName'],
        'stockDroneId': value['stockDroneId'],
        'stockDroneName': value['stockDroneName'],
        'tags': value['tags'],
        'target': value['target'],
        'targetStatus': value['targetStatus'],
        'targetType': value['targetType'],
        'team': value['team'],
        'timeEnd': value['timeEnd'],
        'timeStart': value['timeStart'],
        'type': value['type'],
        'video': value['video'],
        'withRepeater': value['withRepeater'],
        'zone': value['zone'],
    };
}

